import type { AppTheme } from '@backstage/core-plugin-api';
import { Icon } from '@publicplan/kern-react-kit';
import { KernThemeProvider } from './KernThemeProvider';
import { kernDarkTheme, kernLightTheme } from './kernThemes';

/**
 * The two KERN themes in the shape Backstage expects for its theme picker. The IDs stay
 * `light`/`dark` so that stored user preferences keep working; the titles are German.
 */
export const kernLightAppTheme: AppTheme = {
  id: 'light',
  title: 'KERN hell',
  variant: 'light',
  icon: <Icon name="light-mode" />,
  Provider: ({ children }) => (
    <KernThemeProvider theme={kernLightTheme} variant="light">
      {children}
    </KernThemeProvider>
  ),
};

export const kernDarkAppTheme: AppTheme = {
  id: 'dark',
  title: 'KERN dunkel',
  variant: 'dark',
  icon: <Icon name="dark-mode" />,
  Provider: ({ children }) => (
    <KernThemeProvider theme={kernDarkTheme} variant="dark">
      {children}
    </KernThemeProvider>
  ),
};
